/**
 * Utility function to remove emojis from text input
 * Blocks a comprehensive range of emoji characters including:
 * - Emoticons (😀-😿)
 * - Symbols & Pictographs (🌀-🗿)
 * - Transport & Map Symbols (🚀-🛿)
 * - Supplemental Symbols and Pictographs
 * - Additional emoji ranges
 */
export const removeEmojis = (text: string): string => {
  const emojiRegex =
    /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{FE00}-\u{FE0F}\u{1F1E6}-\u{1F1FF}]/gu;
  return text.replace(emojiRegex, '');
};
